(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-al-announcement]').forEach((bar) => {
    const messages = [...bar.querySelectorAll('.al-announcement__message')];
    if (messages.length < 2 || reducedMotion) return;
    let active = 0;
    window.setInterval(() => {
      messages[active].classList.remove('is-active');
      active = (active + 1) % messages.length;
      messages[active].classList.add('is-active');
    }, 6000);
  });

  const sticky = document.querySelector('[data-al-sticky-add]');
  const primaryButton = document.querySelector('main[data-template="product"] .product-form__submit');
  if (sticky && primaryButton && window.matchMedia('(max-width: 749px)').matches) {
    sticky.hidden = false;
    const stickyVariant = sticky.querySelector('[data-al-sticky-variant]');
    const mainProduct = document.querySelector('main[data-template="product"]');
    const syncVariant = () => {
      const current = mainProduct?.querySelector('.product-variant-id:not([data-al-sticky-variant])');
      if (!current || !stickyVariant) return;
      stickyVariant.value = current.value;
      stickyVariant.disabled = current.disabled;
      const stickyButton = sticky.querySelector('button[name="add"]');
      if (stickyButton) stickyButton.disabled = current.disabled;
    };
    mainProduct?.addEventListener('change', () => window.setTimeout(syncVariant));
    syncVariant();
    const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    observer.observe(primaryButton);
  }
})();
